<template>
    <div class="add-mentee-form">   
      <div class="add-form-wrapper">
        <h3 class="add-form-heading">Add Mentee</h3>
      </div>

      <div class="content-main-wrapper center">

        <div class="row" v-show="successMessage != ''">
          <div class="col-12 p-0">
            <div class="alert alert-success" role="alert">
              {{ successMessage }}
            </div>
          </div>
        </div>

        <form @submit.prevent="onSubmit">
		      <div class="row">
		        
              <div class="col-12 p-0">
      			  <input
      					type="first_name"
      					name="first_name"
      					id="first_name"
      					class="col-12 col-sm-12 input-height-35 form-control"
      					ref="first_name"
      					v-validate="{ rules: { required: true, regex: nameRegex() } }"
      					v-model="first_name"
                data-vv-as="First Name"
                placeholder="First Name"
                maxlength="180">
      			  <div v-if="verrors.firstByRule('first_name', 'required')" class="validate-warning-msg">The First Name is required</div>
              <div v-if="verrors.firstByRule('first_name', 'regex')" class="validate-warning-msg">The First Name should only contain - and _</div>
            </div>
         
             <div class="col-12 p-0" style="margin-top: 10px;">     
              <input
                type="last_name"
                name="last_name"
                id="last_name"
                class="col-12 col-sm-12 input-height-35 form-control"
                ref="last_name"
                v-validate="{ rules: { required: true, regex: nameRegex() } }"
                v-model="last_name"
                data-vv-as="Last name"
                placeholder="Last Name"
                maxlength="180">
              <div v-if="verrors.firstByRule('last_name', 'required')" class="validate-warning-msg">The Last Name is required</div>
              <div v-if="verrors.firstByRule('last_name', 'regex')" class="validate-warning-msg">The Last Name should only contain - and _</div>
            </div>
         
            <div class="col-12 p-0" style="margin-top: 10px;">
              <input
                  type="email_addr"
                  name="email"
                  id="email_addr"
                  class="col-12 col-sm-12 input-height-35 form-control"
                  ref="email_addr"
                  v-validate="'required|email'"
                  v-model="email_addr"
                  data-vv-as="Email Address"
                  placeholder="Email Address"
                  maxlength="180">
              <div v-show="verrors.has('email')" class="validate-warning-msg">{{ verrors.first('email') }}</div>
            </div>

            <div class="col-12 p-0" style="margin-top: 10px;">         
              <input
                  type="phone_number"
                  name="phone_number"
                  id="phone_number"
                  class="col-12 col-sm-12 input-height-35 form-control"
                  ref="phone_number"
                  @keyup="adminPhoneValid($event)"
                  @blur="adminPhoneValid($event)"
                  v-validate="{ rules: { regex: adminPhoneRegex() } }"
                  v-model="phone_number"
                  data-vv-as="Phone number"
                  placeholder="Phone Number"
                  maxlength="14">
             <div v-if="verrors.has('phone_number')" class="validate-warning-msg">The Phone Number is invalid</div>
            </div>
        

            <div class="col-12 p-0" style="margin-top: 10px;">
                <label
                    for="hire_date"
                    class="col-12 bold">Hire Date:</label>
                <div class="month-picker-elm-container">
                  <month-picker-input 
                    :default-month="hire_date_month"
                    :default-year="hire_date_year"
                    :clearable="false"
                    :editable-year="false"
                    :date-format="month_picker_date_format"
                    input-class="col-12 col-sm-12 input-height-35 form-control"
                    @input="input_hire_date"
                    :max-date="input_max_date"
                    >
                  </month-picker-input>
                  <i class="fa fa-calendar red-color" aria-hidden="true"></i>
                  <div v-show="verrors.has('hire_date')" class="validate-warning-msg">{{ verrors.first('hire_date') }}</div>
                </div>
            </div>

            <div class="col-12 p-0" style="margin-top: 7px;">
              <label
                  for="mentor"
                  class="col-12 bold"> Assign Mentors: <span class="required">*</span></label>
                  <div class="col-12 col-sm-12 tasklist-assign-wrapper"  v-for="(option, key, index) in groups">
                    <div class="chkboxwrapper">
                      <div class="custom-control custom-checkbox">
                        <input 
                        name="mentor_assigned"
                        :value="option.id" 
                        :id="'add_mentee_mentor_' + option.id" 
                        type="checkbox" 
                        v-model="mentor_assigned"
                        v-validate="'required'"
                        class="custom-control-input"
                        > 
                        <label class="custom-control-label" :for="'add_mentee_mentor_' + option.id">{{ option.groupName }}</label> 
                      </div>
                    </div>
                  </div>
                  <div v-if="verrors.has('mentor_assigned')" class="margin-bottom-5 validate-warning-msg">Mentor is required</div>

            </div>


           <div class="col-12 p-0" style="margin-top: 10px;">
                <label
                    for="roles"
                    class="col-12 bold">Assign Pathway: </label>
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(pathway, key, index) in pathwayList">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="pathway_assigned"
                        :value="pathway.id"                       
                        type="radio" 
                        v-model="pathwaySelected"
                        @change="getPathwaySteps"
                        v-validate="'required'"
                        class="custom-control-input"
                        :id="'add_mentee_pathway_' + pathway.id"
                        >
                      <label class="custom-control-label" :for="'add_mentee_pathway_' + pathway.id">{{ pathway.pathwayName }}</label>
                    </div>
                  </div>
                </div>
                <div class="col-12 pl-0" v-if="pathwayList.length == 0" style="color: #707070;">
                  No Pathways for this account.
                </div>
                <div v-if="verrors.has('pathway_assigned')" class="margin-bottom-5 validate-warning-msg">Pathway is required</div>
           </div>


           <div class="col-12 p-0"  v-if="pathwayList.length > 0" style="margin-top: 10px;">
               <div class="row">
                <div class="col-8 d-inline"> 
                  <label
                      for="roles"
                      class="col-12 bold">Begin at step: </label>
                </div>     
                <div class="col-4">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-checkbox">
                      <input 
                        name="future steps"
                        value="1"                                           
                        type="checkbox" 
                        v-model="showFutureSteps"                      
                        class="custom-control-input"
                        :id="'add_mentee_future_steps'" 
                        >
                      <label class="custom-control-label" :for="'add_mentee_future_steps'">Show future steps</label>
                    </div>
                  </div>
                </div>
               </div> 
                <div class="col-12 col-sm-12 tasklist-assign-wrapper" v-for="(step, key, index) in pathwaySteps">
                  <div class="chkboxwrapper">
                    <div class="custom-control custom-radio">
                      <input 
                        name="Begin at step"
                        :value="step.id"                       
                        type="radio" 
                        v-model="stepSelected"                      
                        class="custom-control-input"
                        :id="'add_mentee_step_' + step.id"
                        >
                      <label class="custom-control-label" :for="'add_mentee_step_' + step.id">{{ step.stepTitle }}</label>
                    </div>
                  </div>
                </div>
           </div>

      </div>

    <div class="submit margin-bottom-15" style="text-align: center;">
        <button :disabled="disable_add_mentee" type="submit" class="btn btn-info ma-blue-btn" @click="buttonAction = 'save'">Add Mentee</button>
         <div class="mt-2 mb-5">
              <button :disabled="disable_add_mentee" type="submit" class="btn btn-link save_add_link" @click="buttonAction = 'save_and_add'" style="color: #00ACEE !important;">Save & Add Another</button>
         </div>
    </div>
   </form>
  </div>
</div>
</template>

<script>
import Vue from 'vue/dist/vue.esm';
import moment from 'moment';
import UserMenu from '../shared/user_menu.vue';
import GoBack from '../shared/goback.vue';
import VeeValidate from 'vee-validate';
import axios from 'axios';
import router from '../../router/index.js';
import { store } from '../../store/store';
import DatePicker from 'vue2-datepicker';
import 'vue2-datepicker/index.css';
import { MonthPickerInput } from 'vue-month-picker';
import { handleMonthPickerYearNavButtons } from '@/components/shared/utils.js';

import Multiselect from 'vue-multiselect';

const today = new Date();
today.setHours(0, 0, 0, 0);

const todayMoment = moment();

Vue.use(VeeValidate, { errorBagName: 'verrors', fieldsBagName: 'vfields'});
Vue.use(MonthPickerInput);

export default {
  data: function () {
    return {
      first_name: '',
      last_name: '',
      phone_number: '',
      email_addr: '',
      mentor: '',
      password: '',
      pw_confirm: '',
      groups: [],
      pathwayList: [],
      pathwaySteps: [],
      pathwaySelected: '',
      stepSelected: '',
      showFutureSteps: 1,
      defaultstep: '',
      accountId: '',
      hire_date: '',
      mentor_assigned: [],
      mentorSelected: [],
      assessments: [],
      assessmentSelected: [],
      courses: [],
      courseSelected: [],
      accountItems: [],
      usertype_options: [],
      isFormAccess: false,
      user_type: '',
      month_picker_date_format: '%n, %Y',
      hire_date_month: todayMoment.month() + 1,
      hire_date_year: todayMoment.year(),
      input_max_date: todayMoment.toDate(),
      assignLicense: 1,
      totalLicense: '',
      successMessage: '',
      disable_add_mentee: false,

    };
  },
 methods: {
  nameRegex: function() {
    return /^[a-zA-Z-_ ']*$/;
  },
  adminPhoneRegex: function() {
    return /^\(?([0-9]{3})\)?[-. ]?([0-9]{3})[-. ]?([0-9]{4})$/;
  },
  getPathwaySteps() {
    axios('/get-pathway-steps-name',
        {
          method: 'GET',
          params: {
            pathway_id: this.pathwaySelected,
          }
        },
      )
      .then(response => {
            this.defaultstep = response.data[0].id;            
            this.pathwaySteps = response.data;
       })
      .catch(error => {

      });
  },
  getMentorLists() {
    axios('/desktop/manager/active-license-count',
    {
      method: 'GET',
      params: {
        account_id: this.$store.state.user_accountid, 
      }
    })
    .then(resp => {
      this.totalLicense = resp.data.hasLicense;
      this.assignLicense = this.totalLicense > 0?1:0;
      if(resp.data.unlimited == true) {
        this.assignLicense = 1; 
      }
      
    })
    .catch(() => {
    });

    axios('/accountgroupsactive',
        {
          method: 'GET',
          params: {
            account_id: this.$store.state.user_accountid,
          }
        },
      )
      .then(response => {
          this.groups = response.data;        
       })
      .catch(error => {

      });
  }, 
  getPathwayLists() {
    axios('/get-pathway-add-mentee',
          {
            method: 'GET',
            params: {
              account_id: this.$store.state.user_accountid,
            }
          },
        )
        .then(response => {
            this.pathwayList = response.data;
         })
        .catch(error => {

        });
  },       
  adminPhoneValid: function(event) {
    var phone_val = this.phone_number;
    this.phone_number = phone_val.replace(/[^0-9]/g, '').replace(/(\d{3})(\d{3})(\d{4})/, '($1) $2-$3');
  },
	onSubmit () {
      if(this.pathwaySelected == '') {
        const fieldErrors =  [];
        var newFieldErr = {field:'pathway_assigned', msg:'Pathway is required', rule:'required'};
        fieldErrors.push(newFieldErr);
        this.$validator.errors.add(fieldErrors);
      }

      this.$validator.validateAll().then((result) => {
        if(!result) {
          return;
        }
        if(this.pathwaySelected != '') {
          this.createMentee();
        }
      })
      .catch(() => {

      });
	},
  createMentee() {
    this.disable_add_mentee = true;
      //make axios call to the API
      
      if (!this.hire_date) {
        this.hire_date = todayMoment.format('YYYY-MM-01');
      }

      axios('/users',
        {
          method: 'POST',
          data: {
                 "username": this.email_addr,
                 "email": this.email_addr,
                 "roles": ['ROLE_MENTEE'],
                 "first_name": this.first_name,
                 "last_name": this.last_name,
                 "phone_number": this.phone_number,
                 "hire_date": this.hire_date,
                 "mentor": this.mentor_assigned,
                 "enabled": true,
                 "pathway_assigned": this.pathwaySelected,
                 "begin_step": this.stepSelected == ''? this.defaultstep: this.stepSelected,
                 "license_assign": this.assignLicense,
                 "show_future_steps": this.showFutureSteps,
                 "signin_count": 0,
                 "account_id": this.$store.state.user_accountid,
                 "user_type": 'mentee',
                 }
        },
      )
      .then(response => {
        this.disable_add_mentee = false;
          //this.flash({ message: response.data.successMsg, variant: 'success' });
          this.successMessage = 'New Mentee Added Successfully!';
          this.doMenteeFormReset();

          if (this.buttonAction == 'save') {
            this.$refs.first_name.focus();
            setTimeout(() => {
              this.successMessage = '';
              this.$parent.hide();
              this.$router.push(this.$router.currentRoute.path)
              this.$router.go();
            }, 2000);               
          }
          else {
            // document.getElementById("first_name").focus();
            this.pathwaySteps = [];
            this.stepSelected = '';
            axios('/desktop/manager/active-license-count',
            {
              method: 'GET',
              params: {
                account_id: this.$store.state.user_accountid, 
              }
            })
            .then(resp => {
              this.totalLicense = resp.data.hasLicense;
              this.assignLicense = this.totalLicense > 0?1:0;
              if(resp.data.unlimited == true) {
                this.assignLicense = 1; 
              }
              
            })
            .catch(() => {
            });

            this.$refs.first_name.focus();
            setTimeout(() => {
              this.successMessage = '';                
            }, 2000); 
          }
       })
      .catch(error => {
        this.disable_add_mentee = false;
          // this.$parent.hide();
          // this.$parent.$parent.getMenteeLicense();

          const fieldErrors =  [{}];
          // var errMsgObj = error.response.data.message;
          var errMsgObj = JSON.parse(error.response.data.message);
          Object.keys(errMsgObj).map(key => {
             var newFieldErr = {field:key, msg:errMsgObj[key]};
             fieldErrors.push(newFieldErr);
             if (key == 'email') {
              this.$refs.email_addr.focus();
             }
          });
          this.$validator.errors.add(fieldErrors);
       });
  },
  navigate(path) {
    router.push(path);
  },
    notBeforeToday(date) {
      return date < today;
    },
    getMentorDisplayText(count, name) {
      if (count == 1) {
          return name[0].text;
      } else {
          var num = (count - 1);
          if (count > 2) {
              var otherText = num + " Others";
          } else {
              var otherText = num + " Other";
          }
          return name[0].text + ", +" + otherText;
      }
    },
    getUserTypeOptions() {
      if (this.$route.name == "addapprentice") {
        this.usertype_options = [
          {value: '', text: 'Select User Type'},
          {value: 'apprentice', text: 'Apprentice'},
        ] 
      } else {
        this.usertype_options = [
          {value: '', text: 'Select User Type'},
          {value: 'mentee', text: 'Mentee'}
        ] 
      }
    },
  
    input_hire_date(data) {
      this.hire_date = data.year + '-' + (data.monthIndex < 10 ? '0' + data.monthIndex : data.monthIndex) + '-01';
    },
    doMenteeFormReset() {
      this.first_name = '';
      this.last_name = '';
      this.phone_number = '';
      this.email_addr = '';
      this.mentor_assigned = [];
      this.pathwaySelected = '';
      this.showFutureSteps = 1;
      this.assignLicense = 1;
      this.$validator.reset();
    },
  },
  components: {
    UserMenu,
    GoBack,
    DatePicker,
    Multiselect,
    MonthPickerInput,
  },
  created: function() {
   
  },
  mounted() {
    handleMonthPickerYearNavButtons();
  },
}
</script>

<style scoped>
.start-button-blue {
    color: #fff;
    background-color: #29A3E4;
    border: 1px solid #29A3E4;
    border-radius: 15px;
    font-size: 13px;
    font-weight: 900;
    padding: 10px 10px 10px 10px;
    line-height: 8px;
    width: 130px; 
}
.tasklist-assign-wrapper label {
  font-weight: normal;
}
.tasklist-assign-wrapper .chkboxwrapper {
  margin-bottom: 5px;
}
.mx-datepicker {
  width: 100%;
}
.signin-form input {
  border: 1px solid #ced4da;
}
.content-main-wrapper {
  width: 90% !important;
  background-color: #FFF !important;
  padding: 25px;
}
input {
  line-height: 17px;
  border-radius: 10px;
  padding-left: 5px !important;
  border: 1px solid #707070;
}
.add-form-heading {
  font-size: 18px;
  font-weight: bold;    
}
.add-form-wrapper {
  margin: 0px 10px 0px 30px; 
}
.add-mentee-form label.bold{
  font-weight: 600;
  padding-left: 0px;
}
/deep/ .month-picker-input-container {
  width: 100% !important;
}
/deep/ .month-picker-input {
  width: 100%;
}
/deep/ .month-picker__container {
  z-index: 9999;
  width: 100% !important;
}
.month-picker-elm-container {
  position: relative;
}
.month-picker-elm-container .fa-calendar {
  position: absolute;
  top: 35%;
  right: 5%;
  pointer-events: none;
  color: #00ACEE;
}
</style>

<style>
.month-picker-input {
  line-height: 17px;
  border-radius: 10px !important;
  display: block;
  width: 100% !important;
  padding-top: 0.575rem !important;
  padding-bottom: 0.575rem !important;
  padding-left: 5px !important;
  padding-right: 5px !important;
  border: 1px solid #707070 !important;
  font-size: 1rem !important;
  font-weight: 400;
}    
@-moz-document url-prefix() {
  .month-picker-input {
    padding-top: 0.375rem !important;
    padding-bottom: 0.375rem !important;
  }  
}

</style>


// WEBPACK FOOTER //
// src/components/manager/add_mentee.vue